module.exports = __webpack_public_path__ + "img/Hirsch_Hall_-_DP-t-22882-013.8ce1b127.jpg";